import clsx from 'clsx';
import { memo } from 'react';

import type { SharedAppLayoutBottomNavProps } from '../types';

import { Icon } from '../../Icon/Icon';
import './BottomNav.css';

export const BottomNav = memo(function BottomNav({
  items,
  label,
  onSelect,
  activeValue,
}: SharedAppLayoutBottomNavProps) {
  return (
    <nav aria-label={label} className="eds-app-layout-bottom-nav">
      {items.map((item) => {
        const isActive = item.value === activeValue;
        return (
          <button
            key={item.value}
            aria-expanded={isActive}
            aria-haspopup="dialog"
            aria-label={item.label}
            className={clsx('eds-app-layout-bottom-nav--item', {
              'eds-app-layout-bottom-nav--item--active': isActive,
            })}
            disabled={item.disabled}
            type="button"
            onClick={() => onSelect(item.value)}
          >
            <span
              aria-hidden="true"
              className="eds-app-layout-bottom-nav--indicator"
            >
              <Icon icon={item.icon} size="m" />
            </span>
            <span
              aria-hidden="true"
              className="eds-app-layout-bottom-nav--label"
            >
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
});

BottomNav.displayName = 'AppLayoutBottomNav';
